import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";

class MetricCpc extends MetricBase {
    constructor() {
        super({
            field: "metric_cpc",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.wego.cpc.chartName"),
            serieLabel: i18n.t("metrics.wego.cpc.serieLabel"),
            tooltip: i18n.t("metrics.wego.cpc.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricCpc;
